import fly from "../config/flyio";

export default {
  // 上传文件appNo
  SaveF(appNo, file) {
    return fly.post(`/VHISLoveYourSelf/SaveF?appNo=${appNo}`, file);
  },
  //獲取上傳文件信息
  GetUploadFilesInfo(appNo) {
    return fly.get(`/VHISLoveYourSelf/GetUploadFilesInfo?AppNo=${appNo}`);
  },

  //返回二进制数据流
  PreviewFile(data) {
    return fly.get(
      `/VHISLoveYourSelf/PreviewFile?AppNo=${data.AppNo}&FileName=${data.FileName}`,
      {
        responseType: "blob",
      }
    );
  },
  //   AppNo: nowAppNo,
  // FileName: file.name,
  //删除文件
  DeleteFile(data) {
    return fly.post(
      `/VHISLoveYourSelf/DeleteFile?AppNo=${data.AppNo}&FileName=${data.FileName}`
    );
  },

  // 通过文件的docid拿到 uuid
  GetUniqueId(docId,appNo) {
    return fly.get(`/VHISLoveYourSelf/GetUniqueId?docId=${docId}&AppNo=${appNo}`);
  },
};
